<template>
  <div>
    <Layout>
      <imageList :imageList="imageList" :isDouble="false" />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/public/layout'
import config from '@/config'
import imageList from '@/component/imageList'
export default {
  data() {
    return {
      imageList: []
    };
  },
  methods: {
  },
  components: {
    Layout,
    imageList
  },
  created() {
    this.imageList = config.pageData.overViewWomen.SPRING22.CAMPAIGN;
  }
}

</script>
